<div class="text" [class.tliFont]="hasParameter('tliFont') || tliFont == true">
	<div *ngIf="!isListItem" [ngClass]="{'boxed':boxed}">
		<span [ngStyle]="{color:color}">{{beforeFirstIcon}}</span>
		<span *ngIf="iconCount > 0" [ngStyle]="" class="icon inline-icon {{getFirstIcon()}}">&nbsp;</span>
		<span *ngIf="iconCount > 0" [ngStyle]="{'color':color}">{{beforeSecondIcon}}</span>
		<span *ngIf="iconCount > 1" [ngStyle]="" class="icon inline-icon {{getSecondIcon()}}">&nbsp;</span>
		<span *ngIf="iconCount > 1" [ngStyle]="{'color':color}">{{afterSecondIcon}}</span>
	</div>
	<div *ngIf="isListItem" [ngClass]="{'boxed':boxed,'dashed':dashed}" [ngStyle]="{'border-color':color}"
		[class.tliFont]="hasParameter('tliFont') || tliFont == true">
		<!--<span *ngIf="dashed && !underlined" class="dashed" [ngStyle]="{'border-color':color}">&nbsp;</span>-->
		<span [ngStyle]="{color:color}" [ngClass]="{'dashedValue':dashed}" class="listItemKey"><span
				[ngStyle]="{color:color}">{{getListItemKey()}}</span></span>
		<span [ngStyle]="{color:color}" [ngClass]="{'dashedValue':dashed}" class="listItemValue"
			*ngIf="valueHidden"><span [ngStyle]="{color:color}">---</span></span>
		<span [ngStyle]="{color:color}" [ngClass]="{'dashedValue':dashed}" class="listItemValue"
			*ngIf="!valueHidden"><span [ngStyle]="{color:color}">{{getListItemValue()}}</span></span>
		<span *ngIf="underlined && lines() <=1" class="hr" [ngStyle]="{'border-color':color}">&nbsp;</span>
		<span *ngIf="underlined && lines() > 1" class="hr-nospace" [ngStyle]="{'border-color':color}">&nbsp;</span>
	</div>
</div>